import { render, staticRenderFns } from "./RegisterStepTwoModal.vue?vue&type=template&id=4fe7951f&"
import script from "./RegisterStepTwoModal.vue?vue&type=script&lang=js&"
export * from "./RegisterStepTwoModal.vue?vue&type=script&lang=js&"
import style0 from "./RegisterStepTwoModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports